module.exports = __webpack_public_path__ + "img/no_bg.6f14e0a7.png";